module.exports = __webpack_public_path__ + "static/assets/56e2d9ca862c88d25bd103a62e8a0e13.png";